(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("electron"), require("path"));
	else if(typeof define === 'function' && define.amd)
		define(["electron", "path"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("electron"), require("path")) : factory(root["electron"], root["path"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_69__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition